import React, { useState } from 'react';
import { submitFeedback } from '../../services/feedbackService';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null); // 'sending' | 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setStatus('sending');
    try {
      await submitFeedback(message);
      setStatus('success');
      setMessage('');
      setTimeout(() => { setShowModal(false); setStatus(null); }, 1500);
    } catch {
      setStatus('error');
    }
  };

  return (
    <footer className="bg-white mt-12 border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center gap-4">
          <p className="text-sm text-gray-500">&copy; 2026 Apprecio. All rights reserved. Made with 💜 in San Francisco.</p>
          <button
            onClick={() => { setShowModal(true); setStatus(null); }}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
          >
            Feedback
          </button>
        </div>
      </div>

      {/* Feedback Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900">Send Feedback</h2>
              <button onClick={() => { setShowModal(false); setStatus(null); }} className="text-gray-400 hover:text-gray-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            {status === 'success' ? (
              <p className="text-green-600 text-sm font-medium py-4 text-center">Thanks for your feedback!</p>
            ) : (
              <form onSubmit={handleSubmit}>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Tell us what you think, report a bug, or suggest an improvement..."
                  rows={4}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 resize-none"
                  required
                />
                {status === 'error' && (
                  <p className="text-red-600 text-sm mt-2">Failed to send. Please try again.</p>
                )}
                <div className="flex justify-end gap-3 mt-4">
                  <button
                    type="button"
                    onClick={() => { setShowModal(false); setStatus(null); }}
                    className="px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={status === 'sending' || !message.trim()}
                    className="px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
                  >
                    {status === 'sending' ? 'Sending...' : 'Submit'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
